import { IAttachmentPanelTab } from "./constants";

export const actionTypes = {
  PANEL_TAB_REQUEST: "PANEL_TAB_REQUEST",
  PANEL_TAB_REQUEST_SUCCESS: "PANEL_TAB_REQUEST_SUCCESS",
  PANEL_TAB_REQUEST_FAILURE: "PANEL_TAB_REQUEST_FAILURE",

  PANEL_TAB_ATTACHMENT_REQUEST: "PANEL_TAB_ATTACHMENT_REQUEST",
  PANEL_TAB_ATTACHMENT_REQUEST_SUCCESS: "PANEL_TAB_ATTACHMENT_REQUEST_SUCCESS",
  PANEL_TAB_ATTACHMENT_REQUEST_FAILURE: "PANEL_TAB_ATTACHMENT_REQUEST_FAILURE",

  DOWNLOAD_ATTACHMENT_REQUEST: "DOWNLOAD_ATTACHMENT_REQUEST",
  DOWNLOAD_ATTACHMENT_REQUEST_SUCCESS: "DOWNLOAD_ATTACHMENT_REQUEST_SUCCESS",
  DOWNLOAD_ATTACHMENT_REQUEST_FAILURE: "DOWNLOAD_ATTACHMENT_REQUEST_FAILURE",

  DELETE_ATTACHMENT_REQUEST: "DELETE_ATTACHMENT_REQUEST",
  DELETE_ATTACHMENT_REQUEST_SUCCESS: "DELETE_ATTACHMENT_REQUEST_SUCCESS",
  DELETE_ATTACHMENT_REQUEST_FAILURE: "DELETE_ATTACHMENT_REQUEST_FAILURE",
};

export const fetchAttachmentTabs = () => ({
  type: actionTypes.PANEL_TAB_REQUEST,
});
export const fetchAttachmentTabsSuccess = (payload: IAttachmentPanelTab[]) => ({
  type: actionTypes.PANEL_TAB_REQUEST_SUCCESS,
  payload,
});
export const fetchAttachmentTabsFailure = (error: any) => ({
  type: actionTypes.PANEL_TAB_REQUEST_FAILURE,
  error,
});

export const fetchAttachments = (payload: string) => ({
  type: actionTypes.PANEL_TAB_ATTACHMENT_REQUEST,
  payload,
});
export const fetchAttachmentsSuccess = (payload: any[]) => ({
  type: actionTypes.PANEL_TAB_ATTACHMENT_REQUEST_SUCCESS,
  payload,
});
export const fetchAttachmentsFailure = (error: string) => ({
  type: actionTypes.PANEL_TAB_ATTACHMENT_REQUEST_FAILURE,
  error,
});

export const fetchDownloadAttachment = (payload: {
  id: string;
  name: string;
}) => ({
  type: actionTypes.DOWNLOAD_ATTACHMENT_REQUEST,
  payload,
});
export const fetchDownloadAttachmentSuccess = (payload: any) => ({
  type: actionTypes.DOWNLOAD_ATTACHMENT_REQUEST_SUCCESS,
  payload,
});
export const fetchDownloadAttachmentFailure = (error: string) => ({
  type: actionTypes.DOWNLOAD_ATTACHMENT_REQUEST_FAILURE,
  error,
});

export const fetchDeleteAttachment = (payload: string) => ({
  type: actionTypes.DELETE_ATTACHMENT_REQUEST,
  payload,
});
export const fetchDeleteAttachmentSuccess = (payload: any) => ({
  type: actionTypes.DELETE_ATTACHMENT_REQUEST_SUCCESS,
  payload,
});
export const fetchDeleteAttachmentFailure = (error: string) => ({
  type: actionTypes.DELETE_ATTACHMENT_REQUEST_FAILURE,
  error,
});
